/**
 * Mega Menu Dynamic Generator
 * 
 * 從 Ghost 的 Secondary Navigation 數據中解析並生成 mega-menu 結構
 * 
 * 命名規則：
 * - 分類標題: 全大寫（例如："INJECTABLES", "SKIN REJUVENATION"）
 * - 子項目: 保持原大小寫
 */

(function ($) {
    'use strict';

    let resizeTimer = null;

    // Decode HTML entities inside data attribute payload before JSON.parse.
    function decodeHtmlEntities(input) {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = input;
        return textarea.value;
    }

    function normalizeNavigationItems(rawItems) {
        if (!Array.isArray(rawItems)) {
            return [];
        }

        return rawItems
            .filter(item => item && typeof item === 'object')
            .map(item => ({
                label: (item.label || '').toString().trim(),
                url: (item.url || '').toString().trim()
            }))
            .filter(item => item.label.length > 0);
    }

    function parseNavigationItemsFromAttribute($el) {
        const attr = $el.attr('data-navigation-items');
        if (!attr) {
            return [];
        }

        try {
            const decoded = decodeHtmlEntities(attr)
                .replace(/,\s*([\]}])/g, '$1')
                .trim();

            return normalizeNavigationItems(JSON.parse(decoded));
        } catch (error) {
            console.warn('Failed to parse data-navigation-items attribute:', error);
            return [];
        }
    }

    function getNavigationItems($el) {
        // First try jQuery's automatic data parser.
        const fromData = normalizeNavigationItems($el.data('navigation-items'));
        if (fromData.length > 0) {
            return fromData;
        }

        // Fallback: parse raw attribute string manually.
        return parseNavigationItemsFromAttribute($el);
    }

    // 檢查字串是否為全大寫（允許空格和 & 符號）
    function isAllUpperCase(str) {
        const cleanStr = str.replace(/[\s&]/g, '');
        return cleanStr === cleanStr.toUpperCase() && /[A-Z]/.test(cleanStr) && !/[\/]/.test(cleanStr);
    }

    // 從導航數據中解析 mega-menu 結構
    function parseMegaMenuData(navigationItems) {
        const categories = [];
        let currentCategory = null;

        navigationItems.forEach(item => {
            const label = item.label.trim();
            const dashMatch = label.match(/^([-–—]+)\s*/);
            const nameWithoutDash = label.replace(/^[-–—]+\s*/, '');

            let isSubItem = false;
            let level = 1;

            if (dashMatch) {
                isSubItem = true;
                level = dashMatch[1].length;
            } else if (!isAllUpperCase(nameWithoutDash) || nameWithoutDash.toUpperCase() === 'M22 AOPT') {
                // 如果不是全大寫，或者剛好是 'M22 AOPT' 這個特例，就當作子項目
                isSubItem = true;
                level = 1;
            } else {
                isSubItem = false;
            }

            if (isSubItem) {
                if (currentCategory) {
                    let url = item.url;

                    if (!url || url === '/' || url.includes('javascript:void(0)')) {
                        const slug = nameWithoutDash.toLowerCase()
                            .replace(/[^\w\s-]/g, '')
                            .trim()
                            .replace(/\s+/g, '-');
                        url = `/${slug}/`;
                    }

                    currentCategory.items.push({
                        name: nameWithoutDash,
                        url: url,
                        level: level
                    });
                }
            } else {
                if (currentCategory) {
                    categories.push(currentCategory);
                }
                currentCategory = {
                    title: nameWithoutDash,
                    items: []
                };
            }
        });

        if (currentCategory) {
            categories.push(currentCategory);
        }

        return categories;
    }

    // 生成 mega-menu HTML
    function generateMegaMenuHTML(categories) {
        if (categories.length === 0) {
            return '';
        }

        let html = '';

        categories.forEach((category, index) => {
            const isLastColumn = (index === categories.length - 1);
            const noDividerClass = isLastColumn ? ' no-divider' : '';

            html += `<div class="mega-column${noDividerClass}">`;
            html += `<h3>${category.title}</h3>`;
            html += '<ul>';

            category.items.forEach(item => {
                const indentClass = item.level > 1 ? ` class="sub-level-${item.level}"` : '';
                html += `<li${indentClass}><a href="${item.url}">${item.name}</a></li>`;
            });

            html += '</ul>';
            html += '</div>';
        });

        return html;
    }

    function hasRenderableMegaMenu($container) {
        return $container.find('.mega-column').length > 0 && $container.find('.mega-column li').length > 0;
    }

    function buildMegaMenuForContainer($container) {
        const navigationItems = getNavigationItems($container);

        if (navigationItems.length === 0) {
            console.warn('No navigation items found. Using fallback content.');
            return false;
        }

        const categories = parseMegaMenuData(navigationItems);

        if (categories.length === 0) {
            console.warn('No categories parsed from navigation items.');
            return false;
        }

        const html = generateMegaMenuHTML(categories);
        if (!html) {
            return false;
        }

        $container.html(html);
        console.log(`Mega menu initialized with ${categories.length} categories.`);
        return true;
    }

    // 初始化 mega-menu
    function initMegaMenu(options) {
        const settings = Object.assign({ force: false }, options);
        const $containers = $('.mega-menu-inner[data-navigation-items]');

        if ($containers.length === 0) {
            console.warn('Mega menu container not found.');
            return;
        }

        $containers.each(function () {
            const $container = $(this);

            try {
                if (!settings.force && hasRenderableMegaMenu($container)) {
                    return;
                }

                buildMegaMenuForContainer($container);
            } catch (error) {
                console.error('Error initializing mega menu:', error);
            }
        });
    }

    // 當 DOM 準備好時初始化
    $(document).ready(function () {
        initMegaMenu();

        // Expose re-init hook for scripts that rebuild nav DOM (e.g., dropdown.js)
        window.GlowUpMegaMenu = window.GlowUpMegaMenu || {};
        window.GlowUpMegaMenu.init = function (force) {
            initMegaMenu({ force: Boolean(force) });
        };

        document.addEventListener('glowup:nav-rebuilt', function () {
            initMegaMenu({ force: true });
        });

        window.addEventListener('resize', function () {
            if (resizeTimer) {
                clearTimeout(resizeTimer);
            }

            resizeTimer = setTimeout(function () {
                initMegaMenu();
                resizeTimer = null;
            }, 180);
        });

        document.addEventListener('visibilitychange', function () {
            if (!document.hidden) {
                initMegaMenu();
            }
        });
        
        // 在小屏幕上為一級菜單(TREATMENTS)添加點擊展開/折疊功能
        $(document).on('click', '.has-mega-menu > a', function(e) {
            if ($(window).width() <= 991) {
                e.preventDefault();
                e.stopPropagation();
                const $menuItem = $(this).closest('.has-mega-menu');
                const willOpen = !$menuItem.hasClass('expanded');
                $menuItem.toggleClass('expanded');

                if (willOpen) {
                    // Default state: second-level categories collapsed.
                    $menuItem.find('.mega-column ul').removeClass('expanded');
                    $menuItem.find('.mega-column h3').removeClass('expanded');
                } else {
                    $menuItem.find('.mega-column ul').removeClass('expanded');
                    $menuItem.find('.mega-column h3').removeClass('expanded');
                }

                // Keep navigation anchored at the top after expanding/collapsing.
                const menuEl = document.querySelector('.gh-head-menu');
                if (menuEl) {
                    menuEl.scrollTop = 0;
                }
            }
        });
        
        // 在小屏幕上為二級菜單添加點擊展開/折疊功能
        $(document).on('click', '.mega-column h3', function(e) {
            if ($(window).width() <= 991) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                
                // 切換子菜單的展開/折疊
                $(this).siblings('ul').toggleClass('expanded');
                // 切換分類標題的活躍狀態
                $(this).toggleClass('expanded');
            }
        });
    });

})(jQuery);
